import { layers } from '@atlaskit/theme/constants';
import { CSM, update } from '@atlassian/customer-service-management-widget-sdk-react';
var belowDialog = layers.dialog() - 1;
export var initCSM = function initCSM(_ref) {
  var siteProp = _ref.site,
    siteId = _ref.siteId,
    widgetId = _ref.widgetId;
  var site = siteProp !== null && siteProp !== void 0 ? siteProp : typeof window !== 'undefined' && window.location.hostname;
  if (!site) {
    return;
  }
  if (site === 'localhost') {
    // if in development and window.location.hostname === 'localhost'
    // we set it to the testing instance's site url. Change if using different one than the one below
    site = 'support-ccp.jira-dev.com';
  }
  CSM({
    site: site,
    siteId: siteId,
    widgetId: widgetId
  });

  // Ensures the widget does not render on top of dialogs (e.g., search).
  update({
    zIndex: belowDialog
  });
};